import { Platforms } from "../utility/platform";

export class DefaultADHelper {

  constructor(p_conf, p_options) {
    this.legacyDRCnf = p_conf; // src/configuration/basicConfiguration.js
    this.options = p_options || { css: '', guiLang: 'en', showDocumentHeader: true };

    // Create ObjectURL with 1x1 px transparent image
    this.dummyImmageObjectUrl = URL.createObjectURL(DefaultADHelper.dataURItoBlob('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAACklEQVR42mMAAQAABQABoIJXOQAAAABJRU5ErkJggg=='));
    this.adEnvRegister = {};
  }

  documentLoader(docContexts) {
    return new Promise((resolve, reject) => {
      const promises = [];
      docContexts.forEach((docContext) => {
        const docRequest = docContext.request;
        let docEvent = {
          guid: docRequest.guid,
          contentLanguage: docRequest.contentLanguage,
          options: docRequest.options,

        };
        promises.push(
          this.getActiveDocument(docEvent)
            .then((data) => (docContext.jsonLdData = data))
            .catch((reason) => (docContext.errorReason = reason))
        );
      });
      Promise.all(promises)
        .then(() => resolve())
        .catch((/* reason is added as errorReason into docContext*/) => {
          resolve();
        });
    });
  }

  customFieldsProvider(docTypeGUID) {
    //I am using document without custom fields. You need to implement here working custom fields collection for the docTypeGUID
    //You can open KCenter and put some breakpoints into file ADEnvironmentCreator.js to see what this function should return exactly
    return [];
  }

  getValueList(valueListKey, tenant) {
    //I am using document without custom fields. You need to implement here working value list collection for the docTypeGUID
    return [];
  }

  // Can return string or Promise<string>
  urlRewriter(url, gloobalContext, element, attrName, elementContext) {
    console.kc_log('AD URL rewriter; el=' + element.tagName + ', atr=' + attrName + ', url=' + url);
		return url;
  }

  // End of definition of AD ENV handlers

  addActiveDocumentElement(params, p_docOptions) {
    const kcDocumentHTML = document.createElement("kc-document");

    // parameters only from AdHelperOptions
    kcDocumentHTML.setAttribute('css', this.options.css);
    if (this.options.environmentId) {
      kcDocumentHTML.setAttribute('ad-environment-id', this.options.environmentId);
    }

    // parameters from AdHelperOptions possibly overridden by DocumentOptions
    kcDocumentHTML.setAttribute('language', p_docOptions.guiLang || this.options.guiLang);
    let showDocumentHeader = p_docOptions.hasOwnProperty('showDocumentHeader') ? p_docOptions.showDocumentHeader : this.options.showDocumentHeader;
    kcDocumentHTML.setAttribute('data-show-document-header', showDocumentHeader);

    // parameters only from DocumentOptions
    p_docOptions.anchor && kcDocumentHTML.setAttribute('anchor', p_docOptions.anchor);

    // direct parameters
    kcDocumentHTML.setAttribute('guid', params.guid);
    kcDocumentHTML.setAttribute('mandator', params.mandator || this.legacyDRCnf.defaultMandator);
    kcDocumentHTML.setAttribute('content-language', params.contentLang || this.legacyDRCnf.defaultLanguage);

    if (p_docOptions.linkClickedListener) {
      // Beware that click on image doesn't fire linkclicked custom event
      kcDocumentHTML.addEventListener('linkclicked', p_docOptions.linkClickedListener);
    }

    let contentEl_or_Id = undefined;
    if (p_docOptions.content) {
      contentEl_or_Id = p_docOptions.content;
    } else {
      contentEl_or_Id = this.legacyDRCnf.content;
    }

    let contentEl = undefined;
    if (contentEl_or_Id instanceof HTMLElement) {
      contentEl = contentEl_or_Id;
    } else {
      contentEl = document.getElementById(contentEl_or_Id);
    }

    if (contentEl) {
      // First remove element's children if exist
      while (contentEl.firstChild) {
        contentEl.removeChild(contentEl.lastChild);
      }
      contentEl.appendChild(kcDocumentHTML);
    } else {
      console.error("DocumentRenderer - Element with ID='" + contentEl_or_Id + "' not found");
    }
  }

  getActiveDocument(docEvent) {
    let baseUrlTxt = this.legacyDRCnf.kcenterServiceURL + '/resources';
    let url = new URL(baseUrlTxt);

    let docOptions = docEvent.options;
    url.searchParams.set('luceneQuery', 'docguid:"' + docEvent.guid + '"');

    let langParam = docEvent.contentLanguage;
    if (this.forcedLanguage != null && this.forcedLanguage.length == 2) {
      langParam = this.forcedLanguage;
    }

    url.searchParams.set('contentLanguage', langParam);
    url.searchParams.set('language', langParam);
    if (docOptions) {
      if (docOptions.performActiveSearch) {
        url.searchParams.set('performActiveSearch', "true");
      }
    }
    if (this.options.appAreaId) {
      url.searchParams.set('appAreaIdFilter', this.options.appAreaId);
    }

    let urlTxt = url.href;

    if (this.legacyDRCnf.authenticationURLFragment) {
      urlTxt += '&' + this.legacyDRCnf.authenticationURLFragment;
    }

    console.kc_log('doDocumentRequest() for: ' + urlTxt);

    return fetch(urlTxt, {
      method: 'GET',
      credentials: this.legacyDRCnf.getCredentialsMode(),
      headers: this.createHeaders()
    }).then(response => {
      if (response.ok) {
        return response.json();
      }
      throw new Error('Document not found; guid= ' + docEvent.guid);
    }).then(jsonData => {
      let items = jsonData && jsonData.items;
      if (Array.isArray(items)) {
        return items[0];
      }
      throw new Error('Document not valid; guid= ' + docEvent.guid);
    });
  }

  doBlobRequest(urlTxt) {
    return fetch(urlTxt, {
      method: 'GET',
      credentials: this.legacyDRCnf.getCredentialsMode(),
      headers: this.createHeaders()
    })
      .then(response => response.blob());
  }

  createHeaders(p_headers) {
    let l_headers = {};
    if (p_headers) {
      l_headers = p_headers;
    }
    if (this.legacyDRCnf.getClientJWT() != undefined) {
      if (this.legacyDRCnf.jwtUseAuthorizationHeader) {
        l_headers['Authorization'] = 'Bearer ' + this.legacyDRCnf.getClientJWT();
      }
      else {
        l_getDocumentURL = this.legacyDRCnf.addClientJWTAsURLParam(l_getDocumentURL);
      }
    }

    let csrfHeader = this.legacyDRCnf.getCsrfToken();
    if (csrfHeader) {
      l_headers['GK-CSRF-Token'] = csrfHeader;
    }

    let defaultHeaders = this.legacyDRCnf.getDefaultHeaders();
    if (defaultHeaders) {
      Object.keys(defaultHeaders).forEach(function (key) {
        l_headers[key] = defaultHeaders[key];
      });
    }

    return l_headers;
  }

  getDummyImmageObjectUrl() {
    return this.dummyImmageObjectUrl;
  }

  configureADEnvironment() {
    if (!window.usu_adl) {
        console.error('USU Active documents are not supported');
        return;
    }

    if (this.adEnvRegister[this.options.environmentId]) {
      // AD environment is already registered
      return;
    }

    let platform = new Platforms();
    let usedPlatforms = (!!this.legacyDRCnf.platforms) ? this.legacyDRCnf.platforms : platform.detectPlatforms(window);
    console.log("Detected platforms for envionmentId '%s' -> %s", this.options.environmentId, usedPlatforms);

    try {
        // Workaround till KC-9185 is solved.
        window.usu_adl.configureActiveDocumentEnvironment({
            documentLoader : this.documentLoader.bind(this),
            urlRewritingMethods: [this.urlRewriter.bind(this)],
            customFieldsProvider : this.customFieldsProvider.bind(this),
            valueListProvider : this.getValueList.bind(this),
            extraMapping: {
                "url": {tags: ["usu-audio", "usu-video"]},
                "audio-data-url": {tags: ["usu-audio"]},
                "media-data-url": {tags: ["usu-video"]}
            },
            environmentID: this.options.environmentId,
            platforms: usedPlatforms
        });
        this.adEnvRegister[this.options.environmentId] = true;
    } catch (e) {
        console.info("USU-ADL environment '%s' already exists", this.options.environmentId);
    }
  }

  static dataURItoBlob(dataURI) {
    var mime = dataURI.split(',')[0].split(':')[1].split(';')[0];
    var binary = atob(dataURI.split(',')[1]);
    var array = [];
    for (var i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }
    return new Blob([new Uint8Array(array)], { type: mime });
  }
}